// removed by extract-text-webpack-plugin
module.exports = {"slider-img":"Slider__slider-img__24_LQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Slider/Slider.scss
// module id = 366
// module chunks = 0